import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { useCarAvailabilityLink } from "@tenant/cars";
import { Button, ButtonTypeEnum } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./CarAvailabilityLink.module.scss";
import type { VehicleAvailabilityWithSupplier } from "~core-cars/store";
import { useCarsStyles } from "~core-cars/themes";
import { CarsRawEventName, useEmitCoreCarsRawEvent } from "~core-cars/tracking";
import { CoreCarsComponent } from "~core-cars/types";

export type CarAvailabilityLinkType = PlatformComponentProps & {
  car: VehicleAvailabilityWithSupplier;
};

const COMPONENT_KEY = CoreCarsComponent.CarAvailabilityLink;

export const CarAvailabilityLink = (props: CarAvailabilityLinkType) => {
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { className, children } = props;
  const { goToShop } = useCarAvailabilityLink(props);

  const emitEvent = useEmitCoreCarsRawEvent(
    CarsRawEventName.ClickedCarOnAvailability
  );
  return (
    <div className={clsx(block, className)}>
      {/* TODO a11y, add aria label, handles keyboard */}
      <Button
        className={cn("button")}
        buttonType={ButtonTypeEnum.Wrap}
        onClick={() => {
          emitEvent();
          goToShop();
        }}
      ></Button>

      {/* handles mouse */}
      <div
        onClick={() => {
          emitEvent();
          goToShop();
        }}
        className={cn("card")}
        tabIndex={-1}
      >
        {children}
      </div>
    </div>
  );
};
